<template>
  <div class="describe">
    <div class="header">
      <div class="title">智能门禁硬件描述</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="left">
        <img :src="doordescribeLogo" alt="" />
      </div>
      <div class="right">
        <div class="title">多种开门方式 软硬联动</div>
        <div class="text">
          系统支持多种开门方式，活体人脸识别、密码输入、指纹开门等，自动识别陌生人，减少安全隐患。
        </div>
        <div class="list">
          <div class="item" v-for="item in list" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import doordescribeLogo from "../../../../assets/programme/doordescribeLogo.png";
import yesLogo from "../../../../assets/programme/yesLogo.png";

export default {
  setup() {
    return reactive({
      doordescribeLogo: doordescribeLogo,
      list: [
        {
          id: 1,
          title: "安全性",
          logo: yesLogo,
        },
        {
          id: 2,
          title: "兼容性",
          logo: yesLogo,
        },
        {
          id: 3,
          title: "方便性",
          logo: yesLogo,
        },
      ],
    });
  },
};
</script>

<style scoped>
.describe {
  width: 100%;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  width: 92vw;
  margin: 0 auto;
  margin-top: 16px;
}
.body .left img {
  width: 100%;
}

.body .right .title {
  margin-top: 12px;
  font-size: 14px;
  font-weight: 600;
}
.body .right .text {
  margin-top: 12px;
  font-size: 12px;
  color: #3d3d3d;
}
.body .right .list {
  display: flex;
  justify-content: space-between;
}
.body .right .item {
  display: flex;
  align-items: center;
  margin-top: 12px;
}
.body .right .item img {
  width: 16px;
  margin-right: 10px;
}
.body .right .item div {
  font-size: 14px;
  color: #2a3d50;
}
</style>
